export const menuLists = {
  hasMenu: false,
  Manage: [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: "masonry-view",
    },
    {
      name: "Events",
      path: "/events",
      icon: "notification",
    },
    {
      name: "Search",
      path: "/search",
      icon: "search",
    },
    {
      name: "Devices",
      path: "/devices",
      icon: "wireless-video-surveillance",
    },
    {
      name: "Statistics",
      path: "/statistics",
      icon: "analytics",
    },
    {
      name: "Assistant",
      path: "/assistant",
      icon: "bot",
    },
    {
      name: "Settings",
      path: "/settings",
      icon: "settings",
    },
    {
      name: "Log out",
      // path: "/login",
      icon: "logout",
    },
  ],
};
